import { Component, OnInit } from '@angular/core';
import {DoraRowsPreselectComponent} from '../dora-rows-preselect.component';
import {DataRow} from '../../../DoraData/data-row';
import {DataTupla} from '../../../DoraData/data-tupla';

@Component({
  selector: 'dora-rows-preselect-tab',
  templateUrl: './dora-rows-preselect-tab.component.html',
  styleUrls: ['./dora-rows-preselect-tab.component.scss']
})
export class DoraRowsPreselectTabComponent extends DoraRowsPreselectComponent {



  public onSelect(rowIndex: number, dataRow: DataRow): void {
    this.selectedGrid(dataRow.Id);
  }

  // Methods for Css Class
  public getElementContainerCssClass(rowIndex: number, dataRow: DataRow): string {
    let result: string;

    result = 'tab-element-container ' + dataRow.CssFormat;
    result += (dataRow.selected) ? ' on' : ' off';

    if (rowIndex === 0) {
      result = ' first';
    } else if (rowIndex === this.dataGrid.DataRows.length - 1) {
      result = ' last';
    }
    return result;
  }
  public getElementContentCssClass(rowIndex: number, dataRow: DataRow): string {
    return 'tab-element-content';
  }

  public getElementContent(rowIndex: number, dataRow: DataRow): string {
    let result = '';
    const descriptionTupla: DataTupla = dataRow.getDataTupla('Description');
    if (descriptionTupla !== undefined) {
      result = descriptionTupla.Value;
    }
    return result;
  }

}
